import React, { CSSProperties, ReactElement } from "react"
import './AnimatedCard.css';

export interface BlogCardProps {
    borderWidth?: string,
    blurWidth?: string,
    className?: string,
    children: JSX.Element | JSX.Element[]
}
            
const AnimatedCard: React.FC<BlogCardProps> = ({ borderWidth = '0px', blurWidth = '-60px', 
    className = 'w-full h-full', children }): ReactElement => (
    <div className={`card-wrapper relative flex hover:scale-110 hover:z-10 ${className}`} 
        style={{ 
            '--border-width': borderWidth,
            '--blur-width': blurWidth} as React.CSSProperties}>
        {children}
    </div>
);
            
export default AnimatedCard;
